export default __webpack_public_path__ + "static/media/guide03.4e021314.png";